import * as React from 'react';
import { BrowserRouter, Route, Link, Switch, Redirect, withRouter, NavLink } from "react-router-dom";
import Translate from '../../common/functions/translate';
import { connect } from 'react-redux';
import * as Constants from '../../common/constants';
import * as actionTypes from '../../store/actionTypes';
import AuthService from '../../services/authService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faTablets, faPills, faCog, faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { Menubar } from 'primereact/menubar';
import Growl from '../../common/components/alertMessage/growl';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';

interface IProps {
  lang: string,
  medicineSearchLetter: string,
  medicineSearchName: string,
  history: any,
  onSearchLetterClick: any,
  onSearchNameClick: any,
  isUserLogged: boolean
  onUserLogout: any,
  isUserJustLogged: boolean,
  setUserJustLoggedToFalse: any
}

interface IState {
  userMenu: any,
  isAuthenticated: boolean,
  isVisibleConfirmDialog: boolean;
}

class MainNavigation extends React.Component<IProps, IState> {

  аuthService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isAuthenticated: this.аuthService.isAuthenticated(),
      userMenu: null,
      isVisibleConfirmDialog: false,
    };
  }

  handleMenuItemClick = (menuUrl) => {
    this.props.history.push(menuUrl);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isUserLogged != this.props.isUserLogged) {
      this.setState({
        isAuthenticated: this.аuthService.isAuthenticated()
      })
    }

    if (this.props.medicineSearchLetter) {
      this.props.onSearchLetterClick('');
      this.props.history.push(`${Constants.MedicinesUrl}?letter=${encodeURI(this.props.medicineSearchLetter)}`);
    }

    if (this.props.medicineSearchName) {
      this.props.onSearchNameClick('');
      this.props.history.push(`${Constants.MedicinesUrl}?searchText=${encodeURI(this.props.medicineSearchName)}`);
    }
  }

  handleLogout = () => {
    this.setState({
      isVisibleConfirmDialog: true
    });
  }

  logoutConfirmClick = () => {
    this.аuthService.logout();
    this.props.onUserLogout();
    this.props.history.push('/');
    this.setState({
      isVisibleConfirmDialog: false,
      isAuthenticated: this.аuthService.isAuthenticated()
    })
  }

  public render() {

    const { isAuthenticated } = this.state;

    return (
      <>
        <Growl ref={(el) => this.growl = el} />

        <NavLink exact to="/" >
          <div className="app-navigation-item">
            <FontAwesomeIcon icon={faHome} size="2x" style={{ margin: '5px' }} />
            {Translate('Home')}
          </div>
        </NavLink>

        <NavLink to="/medicines">
          <div className="app-navigation-item">
            <FontAwesomeIcon icon={faTablets} size="2x" style={{ margin: '5px' }} />
            {Translate('Medicines')}
          </div>
        </NavLink>

        <NavLink to="/interactions">
          <div className="app-navigation-item">
            <FontAwesomeIcon icon={faPills} size="2x" style={{ margin: '5px' }} />
            {Translate('Interactions')}
          </div>
        </NavLink>

        {/* <NavLink to="/settings">
          <div className="app-navigation-item">
            <FontAwesomeIcon icon={faCog} size="2x" style={{ margin: '5px' }} />
            {Translate('Settings')}
          </div>
        </NavLink> */}

        {
          isAuthenticated && this.аuthService.isAuthenticated() ?
            // <NavLink to="/user-navigation">
            //   <div className="app-navigation-item">
            //     <FontAwesomeIcon icon={faUser} size="2x" style={{ margin: '5px' }} />
            //     {/* <FontAwesomeIcon icon={faSignOutAlt} size="2x" style={{ margin: '5px' }} /> */}
            //     {this.аuthService.getUserName()}
            //   </div>
            // </NavLink>
            <div onClick={this.handleLogout} >
              <div className="app-navigation-item">
                <FontAwesomeIcon icon={faSignOutAlt} size="2x" style={{ margin: '5px' }} />
                {Translate('Logout')}
              </div>
            </div>
            :
            <NavLink to="/login">
              <div className="app-navigation-item">
                <FontAwesomeIcon icon={faUser} size="2x" style={{ margin: '5px' }} />
                {Translate('Login')}
              </div>
            </NavLink>
        }

        {this.state.isVisibleConfirmDialog ?
          <ConfirmDialog
            headerTitle={Translate("Logout")}
            isVisible={this.state.isVisibleConfirmDialog}
            yesClick={() => { this.logoutConfirmClick() }}
            noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
            {Translate("Are you sure you want to logout")}
          </ConfirmDialog>
          : null}

      </>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang,
    medicineSearchLetter: state.common.medicineSearchLetter,
    medicineSearchName: state.common.medicineSearchName,
    isUserLogged: state.common.isUserLogged,
    isUserJustLogged: state.common.isUserJustLogged
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onSearchNameClick: (medicineSearchName) => dispatch({ type: actionTypes.MEDICINE_SEARCH_BY_NAME, medicineSearchName: medicineSearchName }),
    onSearchLetterClick: (medicineSearchLetter) => dispatch({ type: actionTypes.MEDICINE_SEARCH_BY_LETTER, medicineSearchLetter: medicineSearchLetter }),
    onUserLogout: () => dispatch({ type: actionTypes.USER_LOGOUT }),
    setUserJustLoggedToFalse: () => dispatch({ type: actionTypes.SET_USER_JUST_LOGGED_TO_FALSE })
  }
}

export default withRouter(connect(mapsStateToProps, mapDispatchToProps)(MainNavigation));